const ITEMS = [
  'iGAMING PLATFORM',
  'CRYPTO PAYMENTS',
  'AGGREGATOR',
  'BTC',
  'ETH',
  'USDT',
  'SOFTMAYA GAMING',
  'WHITE LABEL',
  'API INTEGRATION',
  'MULTI-CURRENCY',
];

const Row = ({ items, className, speed, reverse, sep }) => (
  <div className="overflow-hidden mask-fade-x">
    <div className={`marquee-track ${reverse ? 'marquee-reverse' : ''}`} style={{ '--marquee-speed': speed }}>
      {[0, 1].map((k) => (
        <div key={k} className="flex items-center shrink-0" aria-hidden={k === 1}>
          {items.map((item, i) => (
            <span key={`${k}-${i}`} className={`flex items-center ${className}`}>
              {item}
              <span className={sep} />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export const MarqueeSection = () => (
  <section className="relative z-10 py-14 lg:py-20 bg-[#080808] border-y border-[#F4F0E8]/[0.06] overflow-hidden" data-testid="marquee-section">
    <Row
      items={ITEMS}
      speed="80s"
      className="font-display italic font-light text-[clamp(2.2rem,5vw,4.6rem)] text-[#F4F0E8]/85 whitespace-nowrap px-8 lg:px-12 hover:text-[#E8D6AF] transition-colors duration-500"
      sep="ml-16 lg:ml-24 w-2 h-2 rotate-45 border border-[#C8AA73]"
    />
    <div className="mt-6">
      <Row
        items={[...ITEMS].reverse()}
        speed="70s"
        reverse
        className="font-mono-lux text-xs tracking-[0.2em] text-[#7C776E] whitespace-nowrap px-6"
        sep="ml-12 w-6 h-px bg-[#C8AA73]/40"
      />
    </div>
  </section>
);
